import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronLeftMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconChevronLeftMedium"><Path d="M14.1464 5.14645C14.3417 4.95118 14.6582 4.95118 14.8535 5.14645C15.0487 5.34171 15.0487 5.65822 14.8535 5.85348L8.70699 12L14.8535 18.1464C15.0487 18.3417 15.0487 18.6582 14.8535 18.8535C14.6582 19.0487 14.3417 19.0487 14.1464 18.8535L7.64645 12.3535C7.45118 12.1582 7.45118 11.8417 7.64645 11.6464L14.1464 5.14645Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronLeftMedium;
